import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const APP_TAB_BAR_CONTENT_HEIGHT = 54;

export function useAppTabBarHeight() {
  const insets = useSafeAreaInsets();
  return APP_TAB_BAR_CONTENT_HEIGHT + Math.max(insets.bottom, 8);
}
